import { parseString, parseMoney, replaceSpecialChars } from '@/utils/vuex'
import { normaliza, chutaKP, createMD5 } from '@/utils/utils'
import { SUBPRODUTOS_VOLUMOSOS } from '../../utils/types'
import Vue from 'vue'
import { tabelaResumida } from './relatorios'
import cache from '../../plugins/cache'
import _, { findIndex } from 'lodash'
import { getTipos as getTipos_, getAlimentosBasicosCqbal as getAlimentosBasicosCqbal_, getAlimentos as getAlimentos_, getAlimentosEmpresa as getAlimentosEmpresa_, getAlimentosUsuario as getAlimentosUsuario_ } from '../../utils/alimentos'

export const getTipos = async ({ commit }, params = { forceReload: false}) => {
  const { forceReload } = params;
  let tipos = []
  try {
    tipos = await getTipos_({ forceReload })
  } finally {
    commit('setTipos', { tipos })
  }
  return tipos;
}
export const getAditivos = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    Vue.prototype.$getAditivos().then(r => {
      commit('setAditivos', r)
      resolve(r)
    }).catch(r => {
      reject(new Error(r))
    })
  })
}
export const getAlimentosBasicosCqbal = async ({ commit, state }, params = { forceReload: false}) => {
  const { forceReload } = params;
  let alimentos = {}
  let tipos = {}
  try {
    tipos = await getTipos({ commit }, { forceReload })
    alimentos = await getAlimentosBasicosCqbal_({ forceReload })
  } finally {
    commit("setAlimentos", {
      tipos,
      alimentos
    })
  }
}
export const getAlimentosEmpresa = async ({ commit, state }, params = { forceReload: false, idempresa: null, areadaempresa: false, parsed: true}) => {
  const { forceReload, idempresa, areadaempresa, parsed } = params;
  let alimentos = null;
  let meusAlimentos = [];
  const categorias = state.app.categorias_alimentos;
  if (!categorias) await getAlimentosBasicosCqbal({ commit, state });
  try {
    alimentos = await getAlimentosEmpresa_({ forceReload, idempresa, areadaempresa });
    if (!parsed) meusAlimentos = _.clone(alimentos);
    else {
      _.forEach(alimentos, (al) => {
        let alim = _.clone(al);
        alim["nutrientes"] = JSON.parse(al.nutrientes);
        meusAlimentos.push(alim);
      });
    }
  } finally {
    commit("setAlimentosEmpresa", { alimentos: meusAlimentos })
  }
}
export const getAlimentosUsuario = async ({ commit, state }, params = { forceReload: false, idUser: null, parsed: true }) => {
  const { forceReload, idUser, parsed } = params;
  let alimentos = null;
  let meusAlimentos = [];
  const categorias = state.app.categorias_alimentos;
  if (!categorias) await getTipos({ commit, state });
  try {
    alimentos = await getAlimentosUsuario_({ forceReload, idUser });
    if (!parsed) meusAlimentos = _.clone(alimentos);
    else {
      _.forEach(alimentos, (al) => {
        let alim = _.clone(al);
        alim["nutrientes"] = JSON.parse(al.nutrientes);
        meusAlimentos.push(alim);
      });
    }
  } finally {
    console.log({ meusAlimentos })
    commit("setAlimentosUsuario", { alimentos: meusAlimentos })
  }
}
export const getAlimentos = async ({ commit }, params = { forceReload: false, idDieta: null}) => {
  const { forceReload, idDieta } = params;
  let alimentosBasicos = null;
  let alimentosEmp = null;
  let alimentosUsr = null;
  let tipos = null;
  try {
    const res = await getAlimentos_({ forceReload, idDieta });
    alimentosBasicos = _.get(res, 'alimentosBasicos', []);
    alimentosEmp = _.get(res, 'alimentosEmp', []);
    alimentosUsr = _.get(res, 'alimentosUsr', []);
    tipos = _.get(res, 'tipos', []);
  } catch (e) {
    console.log({ e })
  } finally {
    commit('setAlimentos', {
      tipos: tipos,
      alimentos: alimentosBasicos
    })
    commit('setAlimentosEmpresa', { alimentos: alimentosEmp });
    commit('setAlimentosUsuario', { alimentos: alimentosUsr });
    localStorage.setItem('alimentos_emp', JSON.stringify(alimentosEmp))
  }
  return alimentosBasicos;
}
export const relatorioTabelaResumida = ({ commit, state }, { alimentos = {} }) => {
  return tabelaResumida(alimentos)
}
